export default __webpack_public_path__ + "static/media/stadium-bg-ar-ldr.8b54d5b2.svg";